import flatten from 'lodash/flatten'
import idx from 'idx'
import uniq from 'lodash/uniq'
import { createSelector } from 'reselect'

const _user = state => state.auth.user

export const userPermissions = createSelector(
  [_user],
  user => {
    return uniq(flatten(user.userGroups.map(group => group.permissions)))
  },
)

export const userRoles = state => idx(state, _ => _.auth.user.roles) || []
